import MiniHeroSection from "../components/MiniHeroSection";
import ContentBelowHeroBanner from "../components/ContentBelowHeroBanner";
import useSWR from "swr";
import { Helmet } from "react-helmet-async";
import { secureFetcher, SECURITY_CONFIG } from "../config/security";
import DOMPurify from "dompurify";
import ScaleableSection from "../components/ScaleableSection";
import ReadMore from "../components/ReadMore";
import AIReadySection from "../components/about/AIReadySection";

function Leadership() {
  const {
    data: LeadershipData,
    error,
    isLoading,
  } = useSWR(
    `${SECURITY_CONFIG.API_BASE_URL}${SECURITY_CONFIG.WP_PAGES_ENDPOINT}/189`,
    secureFetcher,
  );

  const {
    data: LeadershipPost,
    error: LeadershipPostError,
    isLoading: LeadershipPostIsLoading,
  } = useSWR(
    "https://47.activ8.digital/wp-json/wp/v2/leadership?per_page=100&_embed",
    secureFetcher,
  );
  const {
    data: AboutPageData,
    error: AboutPageDataError,
    isLoading: AboutPageDataLoading,
  } = useSWR(
    "https://47.activ8.digital/wp-json/wp/v2/pages/148",
    secureFetcher,
  );

  if (isLoading || LeadershipPostIsLoading)
    return (
      <div className="loader">
        <img src="assets/img/LoaderSky47.gif" alt="loader" />
      </div>
    );
  if (error || LeadershipPostError) return <p>Error loading data.</p>;

  // Sort LeadershipPost based on leadership_order.member_order
  const sortedLeadershipPost = LeadershipPost?.sort((a, b) => {
    const orderA = parseInt(
      a.acf?.leadership_order?.member_order || "9999",
      10,
    );
    const orderB = parseInt(
      b.acf?.leadership_order?.member_order || "9999",
      10,
    );
    return orderA - orderB;
  });

  return (
    <>
      {LeadershipData && (
        <Helmet>
          <title>{LeadershipData.yoast_head_json?.title}</title>
          <meta
            property="og:title"
            content={LeadershipData.yoast_head_json?.og_title}
          />
          <meta
            property="og:description"
            content={LeadershipData.yoast_head_json?.og_description}
          />
        </Helmet>
      )}

      <MiniHeroSection data={LeadershipData?.acf?.hero_banner} />
      <ContentBelowHeroBanner
        data={LeadershipData?.acf?.content_below_hero_banner}
        center={true}
      />

      <div
        className="ceo-box people-section"
        style={{ margin: "0 auto", padding: "0px" }}
      >
        <div className="ceo-image">
          <img
            src="https://47.activ8.digital/wp-content/uploads/2025/08/Hassan-Abbass-CEO.png"
            alt="CEO-Image"
          />
        </div>
        <div className="ceo-details">
          <div className="ceo-header">
            <h1 className="ceo-name">Hassan Abbas</h1>

            <a
              href="https://www.linkedin.com/in/abbashassan/?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"
              target="_blank"
              rel="noreferrer"
              className="ceo-linkedin-ceo"
            >
              <img src="assets/img/linkedin-logo.png" alt="linkedin-icon" />
            </a>
          </div>

          <h3 className="ceo-title">Chief Executive Officer</h3>

          <p className="ceo-para">
            Hassan brings over two decades of global experience building and
            scaling cloud, data center, and digital infrastructure businesses
            across the Middle East, Europe, Africa, and the Caribbean. He has
            led major transformation programs for operators like Ooredoo,
            Millicom, Vodafone, and Digicel including mission critical IT
            deployments for the FIFA World Cup 2022.
            <br /> <br />
            At Sky47, he is driving the creation of Pakistan’s most advanced
            Tier III/IV data center ecosystem, purpose built for sovereign
            cloud, AI workloads, and national scale digital services.
          </p>
        </div>
      </div>

      {/* Leadership Team Members Section */}
      <div className="people-section">
        <div className="people-grid">
          {sortedLeadershipPost?.map((member) => {
            const name = member.title.rendered;
            const designation =
              member.acf?.leadership_order?.member_designation ||
              "No designation";
            const linkedin =
              member.acf?.leadership_order?.["member_linked_in_profile_url"] ||
              "#";
            const imageUrl =
              member._embedded?.["wp:featuredmedia"]?.[0]?.source_url ||
              "https://47.activ8.digital/wp-content/uploads/2025/07/placeholder.png";
            const member_description =
              member.acf?.leadership_order?.member_description ||
              "No description";
            return (
              <>
                <div key={member.id} className="person-card">
                  <div className="person-image">
                    <img
                      className="leadership-image  "
                      src={imageUrl}
                      alt={name}
                    />
                  </div>
                  <div className="person-info">
                    <div className="linkedin-icon">
                      <a href={linkedin} target="_blank" rel="noreferrer">
                        <img
                          src="assets/img/linkedin-logo.png"
                          alt="linkedin-icon"
                          className="short-card-linkedin"
                        />
                      </a>
                    </div>
                    <div>
                      <h3
                        className={`person-name ${
                          name.length > 15 ? "special-class" : ""
                        }`}
                        style={{ width: "70%", margin: "0 auto" }}
                      >
                        {name}
                      </h3>
                      <p
                        className="person-title"
                        style={{
                          width: "70%",
                          margin: "0 auto",
                          fontSize: "12px",
                          marginBottom: "20px",
                        }}
                        dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(designation || ""),
                        }}
                      ></p>
                      {/* <p
                                            className="person-details"
                                            dangerouslySetInnerHTML={{
                                                __html: DOMPurify.sanitize(member_description || '')
                                            }}
                                        ></p> */}

                      <ReadMore
                        content={member_description}
                        limit={75} /* Jitne characters ke baad cut karna hai */
                      />
                      {/* <p className="person-details">{member_description}</p> */}
                    </div>
                  </div>
                </div>
              </>
            );
          })}
        </div>
      </div>

      <AIReadySection content={AboutPageData?.acf?.ai_ready_section} />
    </>
  );
}

export default Leadership;
